import { ProductMenu } from '../product-menu';
import { Type } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { MenuHeaderCenteredLogoRightDescAndImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-logo-desc-image/menu-header-centered-logo-right-desc-and-image/menu-header-centered-logo-right-desc-and-image.component';
import { MenuHeaderLeftLogoRightDescAndImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-logo-desc-image/menu-header-left-logo-right-desc-and-image/menu-header-left-logo-right-desc-and-image.component';
import { BandedRowMode } from '../../enum/shared/banded-row-mode.enum';
import { BandedRowColorContrast } from '../../enum/shared/banded-row-color-contrast.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class TrueNorthMenu extends ProductMenu {
  getThemeClass(): string {
    return 'true-north-theme';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    if (this.isLandscape()) return MenuHeaderCenteredLogoRightDescAndImageComponent;
    else return MenuHeaderLeftLogoRightDescAndImageComponent;
  }

  getShowHeader(): boolean {
    return true;
  }

  getShowFooter(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getProductWrapperClass(odd: boolean) {
    return odd ? 'product-row-overlay' : '';
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.Badge, 0],
      [SectionColumnProductInfoType.ProductTitle, 1],
      [SectionColumnProductInfoType.Strain, 2],
      [SectionColumnProductInfoType.StrainType, 3],
      [SectionColumnProductInfoType.Brand, 4],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(5),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(6),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(8),
      [SectionColumnProductInfoType.QuantityAndSize, 9],
      [SectionColumnProductInfoType.Quantity, 10],
      [SectionColumnProductInfoType.Size, 11],
      [SectionColumnProductInfoType.VariantType, 12],
      [SectionColumnProductInfoType.Stock, 13],
      [SectionColumnProductInfoType.GradingResults, 14],
      [SectionColumnProductInfoType.VariantPrice, 15],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 16]
    ]);
  }

  bandedRowMode(): BandedRowMode {
    return BandedRowMode.Odd;
  }

  bandedRowColor(rowViewModel: SectionRowViewModel, odd: boolean): string {
    if (this.currentRowIsBanded(odd)) {
      const opacity = '0.65';
      return `rgba(255, 255, 255, ${opacity})`;
    } else {
      return null;
    }
  }

  bandedRowColorContrast(): BandedRowColorContrast {
    return BandedRowColorContrast.Lighten;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Gilroy.ExtraBold_800, FONT.Gilroy.SemiBold_600, FONT.Montserrat.Bold_700, FONT.Montserrat.Medium_500];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/buf2vss.css';
  }

  getTitleSectionTopMargin(): string {
    return '0';
  }

  getTitleSectionBottomMargin(): string {
    return '0';
  }
}
